<template>
    <div class="demo-spin-article">
      <Row style="padding: 5px" :gutter="35">
        <Col :xs="24" :sm="12" class="mb-30" v-for="el in integrations" :key="el.title">
          <Card class="card-container"
                :class="{whiteTheme: el.theme === 'white', noActive: el.status === 'no-active'}"
               @click.native="$router.push({ name: el.view_name })">

            <img :src="el.img" :alt="el.title" class="back-img">
            <div class="body">
              💳
              <h2 class="mb-15">{{el.title}}</h2>
              <p class="mb-40">
                {{el.description}}
              </p>

              <h3>
                {{el.price}}
              </h3>
            </div>

          </Card>
        </Col>

      </Row>

    </div>
</template>

<script>
    export default {
        name: "integrations.vue",

        data() {
            return {
                integrations: [
                    {
                        title: 'Light POS',
                        description: 'Уникальное решение 4 в 1',
                        price: 'от 139 000 тенге',
                        img: '/static/img/integrations/img-1.png',
                        view_name: 'moduleLightPos'
                    },
                    {
                        title: 'Light Kassa',
                        description: 'Фискальная онлайн-касса Гос.реестр №219',
                        price: 'от 990 тенге',
                        img: '/static/img/integrations/img-2.png',
                        view_name: 'moduleLightKassa'
                    },
                    {
                        title: 'Модуль фискализации',
                        description: 'Модуль фискализации с учетными системами',
                        price: '',
                        img: '/static/img/integrations/img-3.png',
                        view_name: 'moduleFiskal'
                    },
                    {
                        title: 'Пакет «Конструктор лояльности»',
                        description: '',
                        price: 'скоро',
                        img: '/static/img/integrations/img-4.png',
                        theme: 'white',
                        status: 'no-active'
                    },
                    {
                        title: 'Пакет «Интернет витрина»',
                        description: '',
                        price: 'скоро',
                        img: '/static/img/integrations/img-5.png',
                        theme: 'white',
                        status: 'no-active'
                    },
                    {
                        title: 'Пакет аналитики',
                        description: '',
                        price: 'скоро',
                        img: '/static/img/integrations/img-6.png',
                        theme: 'white',
                        status: 'no-active'
                    }
                ]
            }
        }
    }
</script>

<style scoped>

  .demo-spin-article {
    padding-right: 275px;
  }
  .card-container {
    padding: 35px 45px;
    position: relative;
    overflow: hidden;
    min-height: 250px;
    border: none;
    cursor: pointer;
  }
  .card-container .back-img {
    position: absolute;
    right: 0;
    bottom: 0;
    z-index: 1;
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
  .card-container p {
    width: 180px
  }
  .card-container .body {
    position: relative;
    z-index: 3;
  }

  .whiteTheme h2, .whiteTheme h3 {
    color: #ffffff
  }

  .noActive {
    cursor: default;
    opacity: 0.6;
    filter: brightness(40%);
  }

  @media screen and (max-width: 1900px) {
    .card-container {
      min-height: 220px;
      padding: 25px 35px;
    }
  }

  @media screen and (max-width: 1500px) {
    .card-container {
      padding: 15px 25px;
    }
  }

  @media screen and (max-width: 1200px) {
    .demo-spin-article {
      padding-right: 0;
    }
  }

  @media screen and (max-width: 767px) {
    .card-container {
      min-height: 180px;
    }

    .card-container p {
      width: 150px;
    }
  }

</style>



// WEBPACK FOOTER //
// src/apps/integrations/integrations.vue